<div class="card">
  <form class="form-horizontal " role="form" style="padding:15px" name="OCRRedirectMockUIForm">
    <div class="row">
      <div class="col-md-12">
        <div [innerHTML]="ocrShowMsg"></div>
      </div>
    </div>
  </form>
</div>